export const BUK_COMPANY_ID = 35;
export const TAPP_COMPANY_ID = 54;
export const CLA_VIRTUAL_ADVISOR_COMPANY_ID = 56;
export const LANK_COMPANY_ID = 57;
export const RELIF_FINANCIAL_ADVISOR_COMPANY_ID = 59;
export const RELIF_FINANCIAL_ADVISOR_SOURCE = 'B2C-LANDING-PAGE';
export const LATAM_VET_SOURCE = 'latam-vet';
